import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { connect } from "react-redux";
import { CtrlCollection } from "@yuigoto/ctrl";

import ResetStyles from "components/login/LoginForm.module.scss";
import {TokenActions} from "../../state/actions/user/TokenActions";
import {GlamboxLoginRenderer} from "../renderers/GlamboxLoginRenderer";
import {ResetPasswordControl} from "../../controls/ResetPasswordControl";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { UiActions } from "state/actions/UiActions";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";

class ResetPasswordForm extends Component {
  constructor (props) {
    super(props);

    this.collection = new CtrlCollection();
    for (let i in ResetPasswordControl) {
      this.collection.add(ResetPasswordControl[i]);
    }
    
    this.state = {
      pendingRequest: false
    };
  }

  render () {
    let isButtonDisabled = this.state.pendingRequest;
    
    return (
      <form className={ResetStyles["login-form"]} onSubmit={this.submitData}>
        {GlamboxLoginRenderer.renderCollection(this.collection)}

        <div className={"login-form__submit-group"}>
          <NavLink to={"/"} 
                   className={classnames("btn btn-light-pink")}>
            Voltar
          </NavLink>
          &nbsp;
          <button type={"submit"} 
                  disabled={isButtonDisabled}
                  className={classnames("btn", "btn-light-lime", "login-form__submit")}>
            Redefinir
          </button>
        </div>
      </form>
    );
  }
  
  // --------------------------------------------------------------------

  submitData = (e) => {
    e.preventDefault();

    let isValid = this.collection.validate();

    if (!isValid) {
      this.forceUpdate();
    } else {
      this.props.loaderShow();
      
      ExecuteRequest(
        GlamboxEndpoints.Open.forgotPassword,
        this.collection.toObject(),
        "POST",
        null,
        null,
        (response) => {
          let {
            result,
            statusCode
          } = response;
          
          this.props.loaderHide();
    
          this.setState({
            pendingRequest: false
          });
          
          if (statusCode === 200) {
            this.props.publishSuccessAlert(
              (result && result.message) 
                ? result.message 
                : "E-mail para reset de senha enviado."
            );
          } else {
            this.props.publishErrorAlert(
              (result && result.message) 
                ? result.message 
                : "Não foi possível realizar a operação."
            );
          }
        }
      );
    }
  }
}

// ----------------------------------------------------------------------

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => ({
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  executeLogin: (email, password) => {
    dispatch(TokenActions.login(email, password));
  }
});

ResetPasswordForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordForm);

// ----------------------------------------------------------------------

export {
  ResetPasswordForm
};


